import type { Dispatch, ReactElement, SetStateAction } from 'react'
import { GeckoColorScale } from 'color-scale-kit'
import type { AssetVizDataConfig } from './AssetVizDataConfig'

const EMPTY_COLOR_SCALE = new GeckoColorScale({})
const EMPTY_MAP = new Map<string, ReactElement>()
const noop = () => {}

/**
 * Default no-op implementations for all data hooks.
 * These provide safe fallback values so AssetViz renders without crashing
 * when no data provider is supplied. Data-dependent features (heatmaps,
 * text data, tooltips, GLTF models) will simply remain in a loading or
 * empty state.
 */
export const defaultDataConfig: AssetVizDataConfig = {
  useColorScale: () => ({
    colorScale: EMPTY_COLOR_SCALE,
    colorScaleMin: undefined,
    colorScaleMax: undefined,
    isLoading: true,
  }),

  useCdfRawValues: () => ({
    buffer: undefined,
    isLoading: true,
  }),

  getDeviationTolerance: () => undefined,

  useCdfBinReading: () => ({
    value: undefined,
    isLoading: false,
  }),

  useResolveAssetUrl: () => ({
    url: undefined,
    isLoading: false,
  }),

  useWebGLContext: () => ({
    assetVizRenderingMap: EMPTY_MAP,
    setAssetVizRenderingMap: noop as Dispatch<
      SetStateAction<Map<string, ReactElement>>
    >,
  }),
}
